export let escapeString = (str) =>
  str.replace(/\\/, "\\\\").replace(/\./, "\\dot").replace(/\$/, "\\dollar");

export let unescapeString = (str) =>
  str
    .replace(/\\dollar/, "$")
    .replace(/\\dot/, ".")
    .replace(/\\\\/, "\\");

export let escapeAll = (strs) => strs.map(escapeString);
export let unescapeAll = (strs) => strs.map(unescapeString);
